import PureLoadable from 'react-17-pure-loadable';

const SkillExpertise = PureLoadable({
  loader: () => import('./SkillExpertise.jsx'),
  displayName: 'SkillExpertise',
});

export default SkillExpertise;
